export const MenuItems = [
    {
        title: 'About',
        url: '/about',
        cName: 'nav-links'
    },
    {
        title: 'Services',
        url: '/services',
        cName: 'nav-links'
    },
    {
        title: 'Projects',
        url: '/projects',
        cName: 'nav-links'
    }
]